import Marquee from "react-fast-marquee";

const ITEMS = [
  "Traitement antirouille",
  "Protection céramique",
  "Polissage de carrosserie",
  "Cire haute performance",
  "Detailing intérieur",
  "Drummondville & environs",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-white/10 bg-white/[0.02] py-6 overflow-hidden">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display font-bold uppercase tracking-[0.25em] text-lg text-outline mx-8 whitespace-nowrap">
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-gold/70 inline-block" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);
